export const getRouteName = word => word.replace(/\\|\//g, '');
